import React, { useContext } from 'react';
import styles from './ZavrsniRad.module.css';
import { ThemeContext } from '../contexts/ThemeContext';
import { Link } from 'react-router-dom';

const ZavrsniRad = ({radId, tema, status, obrazlozenje, mentor,
  predsjednikKomisije, clanKomisije, studentIme}) => {
  const { dark } = useContext(ThemeContext);

  return (
    <div className={styles.zavrsniRad}>
      <div className={styles.zavrsniRadHeader}>
        <Link to={'/zavrsni-radovi/' + radId}>
          <div className={dark ? styles.zavrsniRadHeadingDark : styles.zavrsniRadHeadingLight}>
            {tema}
          </div>
        </Link>
        <div className={styles.zavrsniRadStatus}>{"Status rada: " + status}</div>
      </div>
      <div className={styles.zavrsniRadBody}>{obrazlozenje}</div>
      <div className={dark ? styles.zavrsniRadStatusFooterDark : styles.zavrsniRadStatusFooterLight}>
        <div className={styles.statusItem}>{"Predsjednik komisije: " + predsjednikKomisije}</div>
        <div className={styles.statusItem}>{"Mentor: " + mentor}</div>
        <div className={styles.statusItem}>{"Član komisije: " + clanKomisije}</div>
        <div className={styles.statusItem}>{studentIme ? "Student: " + studentIme : null}</div>
      </div>
    </div>
  );
}

export default ZavrsniRad;